import React from 'react';
import {useParams} from "react-router-dom";
import parse from 'html-react-parser';
import '../../assets/css/pages/mediaEvent/details.scss';
import DataLoader from "../../components/loader/dataLoader";
import useMediaAndEvent from "../../hooks/public/useMediaAndEvent";

const Details = () => {
    const {id} = useParams();
    const {data,isLoading} = useMediaAndEvent(id);
    const {detailImageBase64, detailDescription, detailImageTag} = data;

    return (
        <section className='media-event-details-section'>
            <div className='custom-container'>
                <div className='content-section'>
                    <h1 className='page-title'>Media & Event Details</h1>
                    <div className='content-body'>
                        {isLoading && <DataLoader/>}
                        {
                            data &&
                            (
                                <>
                                    <img width='100%' style={{objectFit: "cover"}}
                                         className="rounded overflow-hidden"
                                         src={`data:image/jpg;base64,${detailImageBase64 ?? ''}`}
                                         alt={detailImageTag ?? ''}
                                    />
                                    <h2 className='content___body-title'>Description</h2>
                                    {parse(detailDescription ?? '')}
                                </>
                            )
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Details;
